import { useRoutes } from "react-router-dom";
import CreateCard from "../../Component/CreateCard.js"
import EditFormRoute from "../../Component/Forms/EditFormRoute.js"

import ManageUsers from "./ManageUsers/View.js"

import UserProfile from "./UserProfile/View.js"

import IpTracking from "./IpTracking/View.js"

import IncompleteProfile from "./IncompleteProfile/View.js"

import AbusiveProfiles from "./AbusiveProfiles/View.js"

import SuggestedEmails from "./SuggestedEmails/View.js"

import Coupon from "./CouponList/View.js"
import AddCoupon from "./CouponList/Create.js"

import InvitedUserList from "./InvitedUserList/View.js"
import AddInvitedUserList from "./InvitedUserList/Create.js"

import ProtectedRoute from "../RouteProtect.js"

const CarrierCardArray = [
    {
        title: "Manage Users",
        path: "manageUsers",
        auth: "carrier",
    },
    {
        title: "User Profile",
        path: "userProfile",
        auth: "carrier",
    },
    {
        title: "Incomplete Profile",
        path: "incompleteProfile",
        auth: "carrier",
    },
    {
        title: "IP Tracking",
        path: "ipTracking",
        auth: "carrier",
    },
    {
        title: "Abusive Profiles",
        path: "abusiveProfiles",
        auth: "carrier",
    },
    {
        title: "Suggested Emails",
        path: "suggestedEmails",
        auth: "carrier",
    },
    {
        title: "Coupon List",
        path: "couponList",
        auth: "carrier",
    },
    {
        title: "Invited User List",
        path: "invitedUserList",
        auth: "carrier",
    },
]


const RoutesArray = [
    {
        path: "/",
        element: <CreateCard cardJson={[...CarrierCardArray]} />
    },
    {
        path: "*",
        element: <h1>This is 404</h1>
    },
    {
        path: "manageUsers/*",
        element:
            (
                <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                    <ManageUsers />
                </ProtectedRoute>
            )
    },
    {
        path: "userProfile/*",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <UserProfile />
            </ProtectedRoute>
        )
    },
    {
        path: "incompleteProfile/*",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <IncompleteProfile />
            </ProtectedRoute>
        )
    },
    {
        path: "ipTracking/*",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="ipTracking" >
                <IpTracking />
            </ProtectedRoute>
        )
    },
    {
        path: "abusiveProfiles/*",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <AbusiveProfiles />
            </ProtectedRoute>
        )
    },
    {
        path: "suggestedEmails/*",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <SuggestedEmails />
            </ProtectedRoute>
        )
    },
    {
        path: "couponList/*",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <Coupon />
            </ProtectedRoute>
        )
    },
    {
        path: "couponList/addcoupon",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <AddCoupon />
            </ProtectedRoute>
        )
    },
    {
        path: "invitedUserList/*",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <InvitedUserList />
            </ProtectedRoute>
        )
    },
    {
        path: "invitedUserList/addInvitedUserList",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <AddInvitedUserList />
            </ProtectedRoute>
        )
    }
];


export default function MangeRoutes() {
    return useRoutes(RoutesArray)
};